import React from 'react';
import { Text, keyframes } from '@chakra-ui/react';

const gradientAnimation = keyframes`
  0% { 
    background-position: 0% 50%;
    text-shadow: 0 0 6px rgba(56, 178, 172, 1);
  }
  25% { 
    background-position: 25% 50%;
    text-shadow: 0 0 6px rgba(245, 101, 101, 1);
  }
  50% { 
    background-position: 50% 50%;
    text-shadow: 0 0 6px rgba(66, 153, 225, 1);
  }
  75% { 
    background-position: 75% 50%;
    text-shadow: 0 0 6px rgba(113, 128, 150, 1);
  }
  100% { 
    background-position: 100% 50%;
    text-shadow: 0 0 6px rgba(56, 178, 172, 1);
  }
`;

export const GlowingText = ({ children }: React.PropsWithChildren<{}>) => (
  <Text
    as="span"
    fontWeight="bold"
    transition="all 0.3s ease"
    flex={1}
    whiteSpace={'nowrap'}
    sx={{
      background:
        'linear-gradient(90deg, #38b2ac, #f56565, #4299e1, #718096, #38b2ac)',
      backgroundSize: '200% auto',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
      animation: `${gradientAnimation} 3s linear infinite`,
    }}
    _hover={{ transform: 'scale(1.05)' }}
  >
    {children}
  </Text>
);
